// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--mJmS-";
export var CreateProjectLink = "styles-module--CreateProjectLink--ENGxv";
export var Footer = "styles-module--Footer--Dvpkh";
export var Message = "styles-module--Message--hItDI";
export var Wrapper = "styles-module--Wrapper--U+zF4";